export const SET_SLIDERPHOTO = 'SET_SLIDERPHOTO'
export const SET_GROUPPHOTOS = 'SET_GROUPPHOTOS'